import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, ChildActivationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { AppComponent } from 'src/app/app.component';
import { Breadcrumb } from '../sidebar/navigation.model';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.css']
})
export class BreadcrumbComponent implements OnInit {

  activeLink:string = "";
  role: any;
  //breadcrumbs: [] = [];
 // role: any;

  constructor(private router: Router, private route: ActivatedRoute, private app: AppComponent) {

    this.role = this.app.currentRole;

    this.activeLink = this.router.url;
      if (this.activeLink=="" || this.activeLink=="/"){
        this.route.url.subscribe(response => {
          this.activeLink = response[0]['path'];
        });
      }
    // this.router.events
    //     .pipe(filter(event => event instanceof ChildActivationEnd))
    //     .subscribe(event => {
    //         let snapshot = (event as ChildActivationEnd).snapshot;
    //         while (snapshot.firstChild !== null) {
    //             snapshot = snapshot.firstChild;
    //         }
    //         this.breadcrumbs = snapshot.data.breadcrumbs;
    //     });
  }

  ngOnInit() {
  }

  // isFinalLink(breadcrumb: Breadcrumb) : boolean{
  //   return breadcrumb.active!=null && breadcrumb.active!=false;
  // }

}
